// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./../../css-loader/index.js?minimize!./../../vue-loader/lib/style-rewriter.js?id=data-v-450f60ed!./../../vue-loader/lib/selector.js?type=styles&index=0!./switch-3.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!./../../vue-loader/node_modules/vue-style-loader/lib/addStylesClient.js")("0ce6222c", content, true);
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!./../../css-loader/index.js?minimize!./../../vue-loader/lib/style-rewriter.js?id=data-v-450f60ed!./../../vue-loader/lib/selector.js?type=styles&index=0!./switch-3.vue", function() {
     var newContent = require("!!./../../css-loader/index.js?minimize!./../../vue-loader/lib/style-rewriter.js?id=data-v-450f60ed!./../../vue-loader/lib/selector.js?type=styles&index=0!./switch-3.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-450f60ed!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-markdown-loader/_cache/switch-3.vue
// module id = 224
// module chunks = 0